"use client"

import Title from "@/components/common/Typography/Title"
import { Col, Image, Row, theme } from "antd"
import TEBreadcrumb from "../common/TEBreadcrumb"
import { useTranslation } from "react-i18next"

const Introduction = () => {
  const token = theme.useToken().token
  const { t } = useTranslation()

  return (
    <Row
      className="introduction__wrapper"
      justify='center'
    >
      <Col span={24} className="introduction">
        <Row>
          <TEBreadcrumb
            separator="|"
            items={[
              {
                title: t("common.home"),
                path: '/'
              },
              {
                title: t("common.introduction"),
                path: '/gioi-thieu'
              }
            ]}
          />
        </Row>
        <Row>
          <Col span={24}>
            <Image
              preview={false}
              width={"100%"}
              style={{ maxWidth: "50rem" }}
              src="/static/images/travel-easy-logo-v2-2x.jpg"
            />
          </Col>
        </Row>
        <Row>
          <Title level={4} type='secondary'>
            Chúng tôi là một thương hiệu mới với sứ mệnh mang đến những giải pháp du lịch thuận tiện, nhanh chóng và uy tín.
          </Title>
        </Row>
        <Row>
          <Title style={{ color: token.colorPrimary, marginBottom: 0 }} level={2}>
            TẦM NHÌN
          </Title>
        </Row>
        <Row>
          <Title level={4} type='secondary' style={{ marginTop: '1rem' }}>
            Bằng khát vọng đem đến những trải nghiệm du lịch thuận tiện, dễ dàng, thân thiện, chuyên nghiệp. TRAVEL EASY quyết tâm trở thành một
            doanh nghiệp cung cấp các giải pháp du lịch chuyên nghiệp.
            Bên cạnh đó tạo ra một môi trường kinh doanh phát triển, minh bạch, chuyên nghiệp nhằm kiến tạo một cuộc sống chất lượng hơn cùng
            TRAVEL EASY .
          </Title>
        </Row>
        <Row>
          <Title style={{ color: token.colorPrimary, marginBottom: 0 }} level={2}>
            SỨ MỆNH
          </Title>
        </Row>
        <Row>
          <Title level={4} type='secondary' style={{ marginTop: '1rem' }}>
            Vì một cuộc sống tốt đẹp hơn cho người Việt. Đem thương hiệu từ Việt Nam vươn ra thế giới.
          </Title>
        </Row>
        <Row>
          <Title style={{ color: token.colorPrimary, marginBottom: 0 }} level={2}>
            GIÁ TRỊ CỐT LÕI
          </Title>
        </Row>
        <Row>
          <Title level={4} type='secondary' style={{ marginTop: '1rem' }}>
            DỄ DÀNG - CHUYÊN NGHIỆP - PHÁT TRIỂN
          </Title>
        </Row>
        <Row>
          <Title style={{ color: token.colorPrimary, marginBottom: 0 }} level={2}>
            KHẨU HIỆU DOANH NGHIỆP
          </Title>
        </Row>
        <Row>
          <Title level={4} type='secondary' style={{ marginTop: '1rem' }}>
            DU LỊCH THẬT DỄ ! TA ĐI THÔI
          </Title>
        </Row>
        <Row>
          <Title style={{ color: token.colorPrimary, marginBottom: 0 }} level={2}>
            TÍNH CÁCH THƯƠNG HIỆU
          </Title>
        </Row>
        <Row gutter={[20, 20]} style={{ marginTop: '2rem' }}>
          {[
            {
              title: "DỄ DÀNG",
              desc: "Trọng tâm của TRAVEL EASY là tạo ra các sản phẩm, dịch vụ lữ hành thuận tiện DỄ DÀNGcho mọi người, mọi lúc, mọi nơi... "
            },
            {
              title: "TẬN TÂM",
              desc: "Sức mạnh của TRAVEL EASY đến từ yếu tố con người, chúng tôi có đội ngũ nhân sự chuyên nghiệp tận tâm phục vụ khách hàng 24/7"
            },
            {
              title: "Phát triển",
              desc: "Bên cạnh việc tạo ra dịch vụ du lịchdễ dàng. TRAVEL EASY còn xây dựng nâng cấp hạ tầng công nghệ, trao dồikỹ năng nhân sự để tạo nên một TRAVEL EASY phát triển mạnh mẽ."
            },
            {
              title: "Chia sẽ",
              desc: "Cùng TRAVEL EASY lan toả và chia sẻ những giá trị tốt đẹp. Kiến tạo cồng đồng nâng tầm chất lượng  cuộc sống..."
            }
          ].map(({ title, desc }) => {
            return (
              <Col xl={6}>
                <Row style={{ marginBottom: '0.5rem' }}>
                  <Col style={{ height: '0.4rem', width: '6rem', backgroundColor: token.colorPrimary }} />
                </Row>
                <Row>
                  <Title style={{ color: token.colorPrimary, marginTop: 0 }} level={4}>
                    {title}
                  </Title>
                </Row>
                <Row>
                  <Title style={{ marginTop: 0 }} level={5} type='secondary'>
                    {desc}
                  </Title>
                </Row>
              </Col>
            )
          })}

        </Row>
        <Row>
          <Title style={{ color: token.colorPrimary, marginBottom: 0 }} level={2}>
            CÂU CHUYỆN THƯƠNG HIỆU
          </Title>
        </Row>
        <Row>
          <Title level={4} type='secondary' style={{ marginBottom: 0, marginTop: '1rem' }}>
            Lấy cảm hứng từ sự ĐƠN GIẢN, DỄ DÀNG trong việc khám phá những vùng đất mới...
          </Title>
        </Row>
        <Row>
          <Title level={4} type='secondary' style={{ marginTop: 0 }}>
            TRAVEL EASY sinh ra nhằm giúp khách hàng đơn giản, nhanh gọn, tối ưu chi phí trong việc đặt vé máy bay,  booking khách sạn...
          </Title>
        </Row>
        <Row>
          <Title level={4} type='secondary' style={{ marginBottom: 0 }}>
            Từ đó những KHÁCH HÀNG của TRAVEL EASY sẽ được tận hưởng dịch vụ vô cùng đơn giản, dễ dàng khiến KHÁCH HÀNG thốt lên DU LỊCH DỄ DÀNG ! TA ĐI THÔI.
          </Title>
        </Row>
        <Row>
          <Title level={4} type='secondary' style={{ marginTop: 0 }}>
            Đó cũng chính là mục thích từ đội ngũ thiết kế muốn truyền tải tới doanh nghiệp và khách hàng như muốn nhấn mạnh chất lượng dịch vụ, giá cả ưu đãi, thao tác dễ dàng mà TRAVEL EASY mang lại.
          </Title>
        </Row>
      </Col>
    </Row>
  )
}

export default Introduction